import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { LeadService } from 'src/app/private/services/lead.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Component({
  selector: 'app-bulk-delete',
  imports: [SharedModule],
  templateUrl: './bulk-delete.component.html',
  styleUrl: './bulk-delete.component.scss'
})
export class BulkDeleteComponent {

  @Output() closeDialog = new EventEmitter<void>();
  @Output() reload = new EventEmitter<void>();
  @Input() selectedProducts: any[] = [];
  isLoading: boolean = false;

  constructor(
    private api : LeadService,
    private messageService: MessageService,
    private localStorage: LocalStorageService
  ) { }

  handleCloseDialog() {
    this.closeDialog.emit();
  }

  handleDelete() {

    const payload = {
      organization_id:this.localStorage.getOrganizationId(),
      lead_id: this.selectedProducts.map((item) => item.lead_id)
    };
    this.isLoading = true;
    this.api.deleteBulkLead(payload).subscribe({
      next: (response) => {
        this.isLoading = false;
        this.reload.emit();
        this.closeDialog.emit();
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: response.message
        });
      },
      error: (error) => {
        this.isLoading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: error.error.message
        });
      }

    }
    );
  }
}
